import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'; // 追加
import '@splidejs/splide/css';

export const Home = {
  init() {
    // 上部スライダー
    const topEl = document.querySelector('.p-home-sliders__top .splide');
    if (topEl) {
      new Splide(topEl, {
        type   : 'loop',
        drag   : false,
        arrows : false,
        pagination: false,
        autoWidth: true,
        gap    : 20,
        autoScroll: {
          speed: 0.8,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount({ AutoScroll });
    }

    // 下部スライダー
    const bottomEl = document.querySelector('.p-home-sliders__bottom .splide');
    if (bottomEl) {
      new Splide(bottomEl, {
        type   : 'loop',
        drag   : false,
        arrows : false,
        pagination: false,
        autoWidth: true,
        gap    : 20,
        focus  : 'center',
        start  : 7,
        autoScroll: {
          speed: -0.8,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      }).mount({ AutoScroll });
    }
    if (document.querySelector('.p-home-news__list .swiper')) {
      const swiperEl = document.querySelector('.p-home-news__list .swiper');
      const links = document.querySelectorAll('.p-home-news__list .p-home-news__link');
      let maxHeight = 0;
      links.forEach((link) => {
        if (maxHeight < link.clientHeight) {
          maxHeight = link.clientHeight;
        }
      });
      swiperEl.style.height = maxHeight + 'px';

      new Swiper('.p-home-news__list .swiper', {
        modules: [Autoplay],
        direction: 'vertical',
        slidesPerView: 'auto',
        loop: true,
        allowTouchMove: false,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        on: {
          resize: (swiper) => {
            maxHeight = 0;
            links.forEach((link) => {
              if (maxHeight < link.clientHeight) {
                maxHeight = link.clientHeight;
              }
            });
            swiperEl.style.height = maxHeight + 'px';
          },
        },
      });
    }
  },
};
